import { render, staticRenderFns } from "./NewRepository.vue?vue&type=template&id=09b234b7&"
import script from "./NewRepository.vue?vue&type=script&lang=js&"
export * from "./NewRepository.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09b234b7')) {
      api.createRecord('09b234b7', component.options)
    } else {
      api.reload('09b234b7', component.options)
    }
    module.hot.accept("./NewRepository.vue?vue&type=template&id=09b234b7&", function () {
      api.rerender('09b234b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/components/NewRepository.vue"
export default component.exports